import { connect } from "react-redux";
import {cognitoLogin, setError, twoFAlogin} from "./actions";
import { navigatePath } from "../../nav/actions";
import { clearOnboardingData } from "../../onboarding/actions";

import Login from "./login";

function mapDispatchToProps(dispatch) {
  return({
    setError: error => { dispatch(setError(error)) },
    navigatePath: (path, args) => { dispatch(navigatePath(path, args))},
    cognitoLogin: (user_id, wlf_id, passwd) => {
      dispatch(cognitoLogin(user_id, wlf_id, passwd))},
    twoFAlogin: (username, passwd) => dispatch(twoFAlogin(username, passwd)),
    clearOnboardingData: () => { dispatch(clearOnboardingData()) },
  })
}

function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.user,
    dwolla: state.dwolla,
    onboarding: state.onboarding,
    isFetching: state.user && state.user.isFetching,
    error: state.user && state.user.error,
    token: state.user.token,
    client: state.client,
    wlf_id: state.app.wlf && state.app.wlf.id,
    config: state.app.config,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)